import { SubButton } from '@/common/buttons/SubButton';
import { EntityPropList } from '@/common/entities/entityProp/EntityPropList';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { ValList } from '@/common/val/ValList';
import { ChainList } from '@/skdr/entities/job/ChainList';

export const OrgDetail = () => {
  const { entityObj } = useEntityMgr();
  const module = useModuleFromRoute();

  const tabSpecs = [
    { id: 'info', label: 'Info', content: <EntityForm /> },
    {
      id: 'config',
      label: 'Configuration',
      content: <EntityForm entity="CONFIG" entityId={entityObj.configId} />,
    },
    {
      id: 'prop',
      label: 'Properties',
      content: (
        <EntityPropList parentEntity="ORG" parentEntityObj={entityObj} />
      ),
    },
    {
      id: 'validation',
      label: 'Configuration Validations',
      content: (
        <ValList parentEntity="CONFIG" parentEntityId={entityObj.configId} />
      ),
    },
  ];

  if (module === 'skdr') {
    tabSpecs.splice(2, 0, {
      id: 'job',
      label: 'Jobs',
      content: <ChainList module={module} />,
    });
  }

  const augButtons = (buttons) => {
    buttons.push(<SubButton />);
  };

  return <EntityDetail tabSpecs={tabSpecs} augButtons={augButtons} />;
};
